import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LayoutState, State } from './layout.model';

export const selectLayoutState = createFeatureSelector< LayoutState>('layout');

export const selectHideFooter = createSelector(
    selectLayoutState,
    state => state.hideFooter
);
